import React from 'react'

class MailLogRow extends React.Component
{
    adjustDateDisplay (date)
    {
       return new Date(date + 'Z').toLocaleString();
    }

    render() {

        return(
            <div style={this.props.even ? highlighted : normal}>
                 <div style={{fontSize: '12px'}} > 
                    <span style={dateStyle}>{this.adjustDateDisplay(this.props.date)} </span> 
                    <span>{this.props.status && this.props.scenario && `${this.props.scenario} e-mail with status ${this.props.status}: `}</span>
                    <span>{this.props.subject}</span>
                </div>
            </div>
        );
    }
}
export default MailLogRow

const highlighted = {
    textAlign:'left',
    padding:'8px',
    backgroundColor: 'rgb(205, 230, 247)'
}

const normal = {
    textAlign:'left',
    padding:'8px',
}

const dateStyle = {
    color: 'rgb(120, 120, 120)'
}


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/MailLogRow.js